import api from './api'

const login = (authentication) => {
  return api.post('auth/signin', authentication)
}

export { login }
